import type { Components, Theme as MuiTheme } from '@mui/material';

export const checkboxTheme: Components<MuiTheme> = {
  MuiCheckbox: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.text.secondary,
        borderRadius: '6px',
        padding: '2px',
        '&.MuiCheckbox-colorError:not(.Mui-checked):not(.Mui-disabled)': {
          color: theme.palette.error.main,
        },
      }),
    },
  },
};
